export const FacebookIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 0C5.3724 0 0 5.3724 0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0Z"
                fill="url(#paint0_linear_5923_34795)"
            />
            <path
                d="M13.7111 15.1187H16.875L17.372 11.9428H13.7111V10.2069C13.7111 8.88778 14.1476 7.71783 15.3964 7.71783H17.4031V4.94667C17.0504 4.89956 16.3047 4.79687 14.8958 4.79687C11.9532 4.79688 10.2282 6.33225 10.2282 9.83062V11.9434H7.20313V15.1193H10.2276L10.2276 23.8483C10.8266 23.9365 11.4336 23.9969 12.0565 23.9969C12.6194 23.9969 13.169 23.9461 13.7111 23.8737L13.7111 15.1187Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_5923_34795"
                    x1="3.5958"
                    y1="3.5958"
                    x2="21.969"
                    y2="21.969"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2AA4F4" />
                    <stop offset="1" stopColor="#007AD9" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export const InstagramIcon = () => {
    return (
        <svg
            key={2}
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.1186 21.9884L4.9028 22C2.21533 22.0024 0.014661 19.806 0.0116071 17.1186L2.03626e-06 4.9028C-0.00244112 2.21533 2.19396 0.014661 4.88143 0.0116071L17.0972 2.03626e-06C19.7847 -0.00244112 21.9853 2.19396 21.9884 4.88143L22 17.0972C22.0031 19.7853 19.806 21.986 17.1186 21.9884Z"
                fill="url(#paint0_radial_5923_34800)"
            />
            <path
                d="M17.1186 21.9884L4.9028 22C2.21533 22.0024 0.014661 19.806 0.0116071 17.1186L2.03626e-06 4.9028C-0.00244112 2.21533 2.19396 0.014661 4.88143 0.0116071L17.0972 2.03626e-06C19.7847 -0.00244112 21.9853 2.19396 21.9884 4.88143L22 17.0972C22.0031 19.7853 19.806 21.986 17.1186 21.9884Z"
                fill="url(#paint1_radial_5923_34800)"
            />
            <path
                d="M10.9982 15.2717C8.64114 15.2717 6.72266 13.3539 6.72266 10.9962C6.72266 8.63858 8.64114 6.7207 10.9982 6.7207C13.3552 6.7207 15.2737 8.63858 15.2737 10.9962C15.2737 13.3539 13.3552 15.2717 10.9982 15.2717ZM10.9982 7.94228C9.31423 7.94228 7.94423 9.31228 7.94423 10.9962C7.94423 12.6802 9.31423 14.0502 10.9982 14.0502C12.6821 14.0502 14.0521 12.6802 14.0521 10.9962C14.0521 9.31228 12.6821 7.94228 10.9982 7.94228Z"
                fill="white"
            />
            <path
                d="M15.5881 7.33432C16.0941 7.33432 16.5042 6.92413 16.5042 6.41814C16.5042 5.91214 16.0941 5.50195 15.5881 5.50195C15.0821 5.50195 14.6719 5.91214 14.6719 6.41814C14.6719 6.92413 15.0821 7.33432 15.5881 7.33432Z"
                fill="white"
            />
            <path
                d="M14.6753 18.9391H7.34583C4.9888 18.9391 3.07031 17.0212 3.07031 14.6636L3.07031 7.33412C3.07031 4.97647 4.9888 3.05859 7.34583 3.05859L14.6753 3.05859C17.0323 3.05859 18.9508 4.97647 18.9508 7.33412V14.6636C18.9508 17.0212 17.0323 18.9391 14.6753 18.9391ZM7.34583 4.28017C5.66189 4.28017 4.29189 5.65017 4.29189 7.33412V14.6636C4.29189 16.3475 5.66189 17.7175 7.34583 17.7175H14.6753C16.3592 17.7175 17.7292 16.3475 17.7292 14.6636V7.33412C17.7292 5.65017 16.3592 4.28017 14.6753 4.28017H7.34583Z"
                fill="white"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_5923_34800"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.17846 22.0159) scale(27.4238)"
                >
                    <stop stopColor="#FFDD55" />
                    <stop offset="0.328" stopColor="#FF543F" />
                    <stop offset="0.348" stopColor="#FC5245" />
                    <stop offset="0.504" stopColor="#E64771" />
                    <stop offset="0.643" stopColor="#D53E91" />
                    <stop offset="0.761" stopColor="#CC39A4" />
                    <stop offset="0.841" stopColor="#C837AB" />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_5923_34800"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(3.54013 -0.274668) scale(18.2094 12.133)"
                >
                    <stop stopColor="#4168C9" />
                    <stop offset="0.999" stopColor="#4168C9" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
};

export const LinkedInIcon = () => {
    return (
        <svg
            width="23"
            height="24"
            viewBox="0 0 23 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_5923_34811)">
                <path
                    d="M21.2966 0.5H1.69769C0.761875 0.5 0 1.24247 0 2.15672V21.839C0 22.7554 0.761875 23.4993 1.69769 23.4993H21.298C22.236 23.4993 23 22.7554 23 21.839V2.15672C23 1.24247 22.236 0.5 21.2966 0.5Z"
                    fill="#0177B5"
                />
                <path
                    d="M3.40912 9.12266H6.82678V20.098H3.40912V9.12266ZM5.11544 3.66016C6.20578 3.66016 7.092 4.54638 7.092 5.63672C7.092 6.72706 6.20578 7.61544 5.11616 7.61544C4.59165 7.6143 4.08894 7.40549 3.71799 7.03467C3.34704 6.66386 3.13805 6.16122 3.13672 5.63672C3.13672 5.37697 3.18792 5.11977 3.28738 4.87982C3.38685 4.63988 3.53263 4.42189 3.7164 4.23832C3.90017 4.05475 4.11832 3.9092 4.35838 3.81C4.59843 3.71079 4.85569 3.65987 5.11544 3.66016ZM8.96075 9.12266H12.2325V10.6227H12.2778C12.7335 9.76019 13.8461 8.85025 15.5122 8.85025C18.9665 8.85025 19.604 11.1237 19.604 14.0784V20.0987H16.195V14.7598C16.195 13.4876 16.172 11.8489 14.4225 11.8489C12.6472 11.8489 12.3741 13.2361 12.3741 14.6664V20.0958H8.96578V9.1205L8.96075 9.12266Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_5923_34811">
                    <rect y="0.5" width="23" height="23" rx="1" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TwitterIcon = () => {
    return (
        <svg
            key={3}
            width={26}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M26 2.365c-.955.404-1.983.674-3.067.801 1.102-.625 1.95-1.621 2.348-2.798a11.022 11.022 0 0 1-3.39 1.224C20.922.61 19.538 0 18.004 0c-2.947 0-5.335 2.26-5.335 5.048 0 .395.049.779.14 1.152C8.374 5.988 4.442 3.975 1.813.921a4.817 4.817 0 0 0-.722 2.542c0 1.753.94 3.296 2.372 4.205a5.629 5.629 0 0 1-2.418-.63v.059c0 2.449 1.84 4.488 4.277 4.952a5.542 5.542 0 0 1-1.401.181c-.345 0-.68-.037-1.006-.093.68 2.002 2.649 3.464 4.982 3.508a11.107 11.107 0 0 1-6.625 2.161c-.432 0-.855-.023-1.272-.072A15.773 15.773 0 0 0 8.178 20c9.81 0 15.177-7.694 15.177-14.368 0-.219-.007-.437-.018-.652A10.253 10.253 0 0 0 26 2.365Z"
                fill="#03A9F4"
            />
        </svg>
    );
};

export const PropertyDescriptionIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx={22.5}
                cy={22.5}
                r={22.5}
                fill="#9AFF04"
                fillOpacity={0.16}
            />
            <path
                d="M13.439 9.082c-.889.2-1.718.887-2.12 1.753-.347.743-.327.068-.312 11.35l.014 10.162.14.408c.178.531.337.805.694 1.197.373.418.75.67 1.276.867l.422.16 4.11.015c4.518.015 4.334.026 4.518-.294.159-.279.07-.697-.179-.841-.084-.052-1.008-.072-4.204-.093-4.061-.026-4.096-.026-4.359-.14a2.096 2.096 0 0 1-1.117-1.16l-.11-.273-.014-10.034c-.01-7.547 0-10.106.045-10.317a1.972 1.972 0 0 1 1.087-1.414l.322-.16h18.12l.322.16c.392.19.635.407.834.732.318.511.308.393.308 4.907 0 4.008.005 4.111.099 4.276.209.356.645.408.923.108l.144-.154.015-4.19c.015-4.71.025-4.59-.347-5.354-.397-.825-1.221-1.48-2.1-1.671-.502-.109-18.05-.109-18.531 0Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
            <path
                d="M16.472 14.627a.607.607 0 0 0-.392.872c.168.34-.308.315 6.463.315h6.136l.168-.175c.144-.15.17-.212.17-.413 0-.3-.18-.531-.473-.599-.238-.056-11.839-.056-12.072 0ZM16.274 19.527c-.178.109-.298.424-.248.63a.667.667 0 0 0 .422.454c.248.067 8.95.072 9.198 0a.611.611 0 0 0 .239-1.053l-.154-.134h-4.647c-4.522 0-4.656.006-4.81.104Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
            <path
                d="M32.724 22.21a2.494 2.494 0 0 0-.744.382c-.209.155-.512.62-.606.914l-.08.247-.427-.382c-.228-.211-.546-.448-.7-.526-.258-.134-.332-.144-.828-.144-.854 0-.74-.078-3.848 2.76-1.459 1.33-2.695 2.486-2.74 2.564-.193.32-.044.779.283.892.164.057.293.046.492-.031.07-.026.08.227.089 2.389.015 2.357.02 2.419.124 2.656.149.34.521.738.854.903l.278.144h8.886l.297-.144c.378-.18.725-.567.88-.954.108-.29.113-.336.128-2.647l.015-2.352.194.057c.387.103.774-.248.724-.666-.02-.18-.074-.258-.471-.645l-.452-.438v-1.522c0-.836-.02-1.661-.05-1.826-.143-.929-.863-1.61-1.747-1.656-.198-.016-.447 0-.55.026Zm.794 1.29c.323.201.338.263.353 1.491.015 1.094.015 1.104-.08 1.032-.054-.041-.382-.33-.724-.64l-.63-.567.019-.47c.015-.52.08-.68.347-.846a.78.78 0 0 1 .358-.103.78.78 0 0 1 .357.103Zm-3.822.48c.06.036 1.023.898 2.144 1.92l2.036 1.856.005 2.75c0 3.013 0 3.023-.293 3.178-.12.067-.333.082-1.092.082h-.939l-.02-.995-.014-.99-.16-.346c-.396-.877-1.2-1.342-2.178-1.264-.85.067-1.524.572-1.847 1.387-.12.3-.129.398-.149 1.27l-.02.943-1.042-.015-1.043-.016-.144-.17-.144-.165v-5.654l1.971-1.806c1.082-.99 2.05-1.851 2.145-1.913.203-.134.6-.16.784-.052Zm.104 7.49c.1.047.233.135.298.197.233.227.258.34.258 1.248v.851h-1.995l.02-.84c.014-.77.024-.852.129-1.043a.857.857 0 0 1 .481-.423c.213-.087.596-.082.81.01Z"
                fill="#67A110"
            />
            <path
                d="M28.684 25.517c-.353.145-.77.547-.943.913-.125.258-.14.351-.14.784 0 .392.02.537.11.733.139.32.526.743.809.892.69.362 1.573.212 2.075-.356.263-.299.387-.562.462-.975.05-.288.05-.392-.02-.686-.14-.588-.432-.97-.948-1.243-.353-.19-1.023-.222-1.405-.062Zm.992 1.238a.596.596 0 0 1 .17.676c-.165.402-.606.49-.91.175-.138-.144-.168-.216-.168-.392 0-.175.03-.247.169-.392.144-.15.203-.175.392-.175.149 0 .263.036.348.108Z"
                fill="#67A110"
            />
            <path
                d="M16.274 24.326c-.178.109-.298.423-.248.63a.667.667 0 0 0 .422.454c.298.082 3.797.067 4.001-.021a.597.597 0 0 0 .377-.583c0-.196-.025-.258-.169-.408l-.168-.175h-2.03c-1.922 0-2.036.005-2.185.103Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
        </svg>
    );
};

export const PropertyDescriptionIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx={22.5}
                cy={22.5}
                r={22.5}
                fill="#C1C1C1"
                fillOpacity={0.16}
            />
            <path
                d="M13.439 9.082c-.889.2-1.718.887-2.12 1.753-.347.743-.327.068-.312 11.35l.014 10.162.14.408c.178.531.337.805.694 1.197.373.418.75.67 1.276.867l.422.16 4.11.015c4.518.015 4.334.026 4.518-.294.159-.279.07-.697-.179-.841-.084-.052-1.008-.072-4.204-.093-4.061-.026-4.096-.026-4.359-.14a2.096 2.096 0 0 1-1.117-1.16l-.11-.273-.014-10.034c-.01-7.547 0-10.106.045-10.317a1.972 1.972 0 0 1 1.087-1.414l.322-.16h18.12l.322.16c.392.19.635.407.834.732.318.511.308.393.308 4.907 0 4.008.005 4.111.099 4.276.209.356.645.408.923.108l.144-.154.015-4.19c.015-4.71.025-4.59-.347-5.354-.397-.825-1.221-1.48-2.1-1.671-.502-.109-18.05-.109-18.531 0Z"
                fill="#C1C1C1"
                stroke="#C1C1C1"
                strokeWidth={0.5}
            />
            <path
                d="M16.472 14.627a.607.607 0 0 0-.392.872c.168.34-.308.315 6.463.315h6.136l.168-.175c.144-.15.17-.212.17-.413 0-.3-.18-.531-.473-.599-.238-.056-11.839-.056-12.072 0ZM16.275 19.527c-.179.109-.298.424-.248.63a.667.667 0 0 0 .422.454c.248.067 8.95.072 9.198 0a.611.611 0 0 0 .239-1.053l-.154-.134h-4.647c-4.522 0-4.656.006-4.81.104Z"
                fill="#C1C1C1"
                stroke="#C1C1C1"
                strokeWidth={0.5}
            />
            <path
                d="M32.723 22.21a2.494 2.494 0 0 0-.744.382c-.209.155-.512.62-.606.914l-.08.247-.427-.382c-.228-.211-.546-.448-.7-.526-.258-.134-.332-.144-.828-.144-.854 0-.74-.078-3.848 2.76-1.459 1.33-2.695 2.486-2.74 2.564-.193.32-.044.779.283.892.164.057.293.046.492-.031.07-.026.08.227.089 2.389.015 2.357.02 2.419.124 2.656.149.34.521.738.854.903l.278.144h8.886l.297-.144c.378-.18.725-.567.88-.954.108-.29.113-.336.128-2.647l.015-2.352.194.057c.387.103.774-.248.724-.666-.02-.18-.074-.258-.471-.645l-.452-.438v-1.522c0-.836-.02-1.661-.05-1.826-.144-.929-.863-1.61-1.747-1.656-.198-.016-.447 0-.55.026Zm.794 1.29c.323.201.338.263.353 1.491.015 1.094.015 1.104-.08 1.032-.054-.041-.382-.33-.724-.64l-.63-.567.019-.47c.015-.52.08-.68.348-.846a.78.78 0 0 1 .357-.103.78.78 0 0 1 .357.103Zm-3.822.48c.06.036 1.023.898 2.145 1.92l2.035 1.856.005 2.75c0 3.013 0 3.023-.293 3.178-.12.067-.333.082-1.092.082h-.938l-.02-.995-.015-.99-.16-.346c-.396-.877-1.2-1.342-2.178-1.264-.85.067-1.524.572-1.847 1.387-.12.3-.129.398-.149 1.27l-.02.943-1.042-.015-1.043-.016-.144-.17-.143-.165v-5.654l1.97-1.806c1.082-.99 2.05-1.851 2.145-1.913.203-.134.6-.16.784-.052Zm.104 7.49c.1.047.234.135.298.197.233.227.258.34.258 1.248v.851H28.36l.02-.84c.014-.77.024-.852.129-1.043.129-.222.248-.33.481-.423.214-.087.596-.082.81.01Z"
                fill="#C1C1C1"
            />
            <path
                d="M28.684 25.517c-.353.145-.77.547-.943.913-.125.258-.14.351-.14.784 0 .392.02.537.11.733.139.32.526.743.809.892.69.362 1.573.212 2.075-.356.263-.299.387-.562.462-.975.05-.288.05-.392-.02-.686-.14-.588-.432-.97-.948-1.243-.353-.19-1.023-.222-1.405-.062Zm.992 1.238a.596.596 0 0 1 .17.676c-.165.402-.606.49-.91.175-.138-.144-.168-.216-.168-.392 0-.175.03-.247.169-.392.144-.15.203-.175.392-.175.149 0 .263.036.348.108Z"
                fill="#C1C1C1"
            />
            <path
                d="M16.275 24.326c-.179.109-.298.423-.248.63a.667.667 0 0 0 .422.454c.298.082 3.797.067 4-.021a.597.597 0 0 0 .378-.583c0-.196-.025-.258-.169-.408l-.168-.175h-2.03c-1.922 0-2.036.005-2.185.103Z"
                fill="#C1C1C1"
                stroke="#C1C1C1"
                strokeWidth={0.5}
            />
        </svg>
    );
};

export const MarketingEmailsIcon = () => {
    return (
        <svg
            width={33}
            height={26}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m25.578 2.284-8.98 7.009L7.41 2.284v.002l.011.01v9.814l9.072 7.16 9.084-6.884V2.284Z"
                fill="#EA4335"
            />
            <path
                d="m27.936.58-2.359 1.704v10.103l7.421-5.698V3.256s-.9-4.902-5.062-2.676Z"
                fill="#FBBC05"
            />
            <path
                d="M25.577 12.386V25.49h5.688s1.619-.167 1.735-2.012V6.688l-7.423 5.698Z"
                fill="#34A853"
            />
            <path
                d="M7.423 25.5V12.11l-.012-.01.012 13.4ZM7.41 2.287 5.065.59C.903-1.634 0 3.266 0 3.266V6.7L7.41 12.1V2.287Z"
                fill="#C5221F"
            />
            <path
                d="M7.411 2.286V12.1l.012.01V2.296l-.012-.01Z"
                fill="#C5221F"
            />
            <path
                d="M0 6.7V23.49c.115 1.847 1.735 2.012 1.735 2.012h5.688L7.41 12.1 0 6.7Z"
                fill="#4285F4"
            />
        </svg>
    );
};

export const MarketingEmailsIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="#E8E8E8" />
            <path
                d="m31.577 12.284-8.98 7.009-9.187-7.009v.002l.011.01v9.814l9.072 7.16 9.084-6.884V12.284ZM33.937 10.58l-2.359 1.704v10.103L39 16.689v-3.433s-.9-4.902-5.062-2.676Z"
                fill="#C1C1C1"
            />
            <path
                d="M31.578 22.386V35.49h5.688s1.619-.167 1.735-2.012V16.69l-7.423 5.697ZM13.422 35.5V22.11l-.012-.01.012 13.4ZM13.41 12.287l-2.345-1.696C6.903 8.367 6 13.267 6 13.267v3.432l7.41 5.403v-9.814Z"
                fill="#C1C1C1"
            />
            <path
                d="M13.41 12.286V22.1l.012.01v-9.814l-.012-.01ZM6 16.7V33.49c.115 1.847 1.735 2.012 1.735 2.012h5.688l-.013-13.4L6 16.7Z"
                fill="#C1C1C1"
            />
        </svg>
    );
};

export const SocialMediaCaptionsIcon = () => {
    return (
        <svg
            width="43"
            height="39"
            viewBox="0 0 43 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M31.5261 0C27.4407 0 24.1289 3.31175 24.1289 7.39724C24.1289 11.4827 27.4407 14.7945 31.5261 14.7945C35.6116 14.7945 38.9234 11.4827 38.9234 7.39724C38.9234 3.31175 35.6116 0 31.5261 0Z"
                fill="url(#paint0_linear_6352_38260)"
            />
            <path
                d="M32.5782 9.32074H34.5285L34.8348 7.36303H32.5782V6.29296C32.5782 5.47979 32.8472 4.75859 33.617 4.75859H34.8541V3.05035C34.6366 3.0213 34.177 2.95801 33.3084 2.95801C31.4945 2.95801 30.4312 3.90447 30.4312 6.061V7.3634H28.5664V9.32111H30.4308V14.702C30.8001 14.7564 31.1742 14.7936 31.5582 14.7936C31.9052 14.7936 32.244 14.7623 32.5782 14.7176V9.32074Z"
                fill="white"
            />
            <path
                d="M13.6156 15.0802L5.55929 15.1327C3.78691 15.1442 2.32749 13.7037 2.31561 11.9313L2.26312 3.87502C2.25164 2.10263 3.69209 0.643217 5.46448 0.631337L13.5208 0.578841C15.2932 0.567364 16.7526 2.00782 16.7645 3.7802L16.817 11.8365C16.8288 13.6093 15.388 15.0687 13.6156 15.0802Z"
                fill="url(#paint1_radial_6352_38260)"
            />
            <path
                d="M13.6156 15.0802L5.55929 15.1327C3.78691 15.1442 2.32749 13.7037 2.31561 11.9313L2.26312 3.87502C2.25164 2.10263 3.69209 0.643217 5.46448 0.631337L13.5208 0.578841C15.2932 0.567364 16.7526 2.00782 16.7645 3.7802L16.817 11.8365C16.8288 13.6093 15.388 15.0687 13.6156 15.0802Z"
                fill="url(#paint2_radial_6352_38260)"
            />
            <path
                d="M9.55619 10.6755C8.00172 10.6842 6.72943 9.42635 6.72077 7.87148C6.71212 6.3166 7.97033 5.04472 9.5248 5.03606C11.0793 5.02741 12.3516 6.28521 12.3602 7.84009C12.3689 9.39496 11.1107 10.6669 9.55619 10.6755ZM9.52928 5.8417C8.41872 5.84788 7.52023 6.75643 7.52641 7.86699C7.53259 8.97756 8.44114 9.87605 9.5517 9.86987C10.6623 9.86369 11.5608 8.95514 11.5546 7.84457C11.5484 6.73401 10.6398 5.83552 9.52928 5.8417Z"
                fill="white"
            />
            <path
                d="M12.5485 5.42189C12.8822 5.42003 13.1512 5.148 13.1493 4.8143C13.1475 4.48059 12.8754 4.21158 12.5417 4.21343C12.208 4.21529 11.939 4.48732 11.9409 4.82102C11.9427 5.15473 12.2147 5.42374 12.5485 5.42189Z"
                fill="white"
            />
            <path
                d="M11.9862 13.0791L7.15243 13.106C5.59796 13.1146 4.32567 11.8568 4.31701 10.302L4.29011 5.46816C4.28145 3.91328 5.53966 2.64139 7.09413 2.63274L11.9279 2.60584C13.4824 2.59718 14.7547 3.85499 14.7634 5.40986L14.7903 10.2437C14.7989 11.7985 13.5407 13.0704 11.9862 13.0791ZM7.09862 3.43838C5.98805 3.44456 5.08956 4.35311 5.09574 5.46367L5.12265 10.2975C5.12883 11.408 6.03738 12.3065 7.14795 12.3004L11.9818 12.2734C13.0923 12.2673 13.9908 11.3587 13.9846 10.2482L13.9577 5.41435C13.9515 4.30378 13.043 3.40529 11.9324 3.41147L7.09862 3.43838Z"
                fill="white"
            />
            <path
                d="M39.2797 25.5975C38.7642 25.8243 38.2097 25.9756 37.6248 26.0472C38.2194 25.6966 38.6769 25.1374 38.8916 24.4768C38.3351 24.8007 37.7187 25.0387 37.0629 25.1641C36.5392 24.6126 35.7923 24.2705 34.9646 24.2705C33.3749 24.2705 32.0863 25.5391 32.0863 27.1033C32.0863 27.3247 32.1124 27.5403 32.1615 27.7496C29.7698 27.6304 27.6485 26.5012 26.2294 24.7875C25.98 25.2063 25.8397 25.6966 25.8397 26.214C25.8397 27.1974 26.3467 28.0631 27.1198 28.5732C26.6479 28.5588 26.2037 28.4284 25.8148 28.2194C25.8148 28.228 25.8148 28.2407 25.8148 28.2527C25.8148 29.627 26.8073 30.7713 28.1227 31.0318C27.8823 31.0972 27.6283 31.1335 27.3664 31.1335C27.1805 31.1335 26.9994 31.1126 26.824 31.0813C27.1903 32.2044 28.2529 33.0252 29.5118 33.0496C28.5268 33.8081 27.2861 34.2624 25.9372 34.2624C25.7041 34.2624 25.4762 34.2493 25.251 34.2222C26.5255 35.0236 28.0389 35.4935 29.6634 35.4935C34.9569 35.4935 37.8528 31.1761 37.8528 27.4307C37.8528 27.3081 37.8489 27.1858 37.843 27.065C38.408 26.6687 38.8951 26.1687 39.2797 25.5975Z"
                fill="#03A9F4"
            />
            <circle
                cx="9.3947"
                cy="29.5968"
                r="7.67069"
                transform="rotate(15 9.3947 29.5968)"
                fill="#0177B5"
            />
            <path
                d="M6.56501 28.2376L8.07901 28.2376L8.07901 33.1081L6.56501 33.1081L6.56501 28.2376ZM7.3209 25.8135C7.80391 25.8135 8.1965 26.2068 8.1965 26.6906C8.1965 27.1745 7.80391 27.5687 7.32122 27.5687C7.08886 27.5682 6.86617 27.4755 6.70184 27.311C6.53751 27.1464 6.44492 26.9234 6.44434 26.6906C6.44434 26.5753 6.46702 26.4612 6.51108 26.3547C6.55514 26.2482 6.61972 26.1515 6.70113 26.07C6.78254 25.9886 6.87918 25.924 6.98552 25.88C7.09187 25.8359 7.20583 25.8134 7.3209 25.8135ZM9.02435 28.2376L10.4737 28.2376L10.4737 28.9032L10.4938 28.9032C10.6956 28.5205 11.1885 28.1167 11.9266 28.1167C13.4568 28.1167 13.7393 29.1255 13.7393 30.4368L13.7393 33.1084L12.2291 33.1084L12.2291 30.7392C12.2291 30.1746 12.2189 29.4474 11.4439 29.4474C10.6574 29.4474 10.5364 30.063 10.5364 30.6977L10.5364 33.1071L9.02658 33.1071L9.02658 28.2366L9.02435 28.2376Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_6352_38260"
                    x1="26.3455"
                    y1="2.21658"
                    x2="37.6714"
                    y2="13.5425"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2AA4F4" />
                    <stop offset="1" stopColor="#007AD9" />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_6352_38260"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(7.71966 15.1311) rotate(-0.318914) scale(18.0864 18.0864)"
                >
                    <stop stopColor="#FFDD55" />
                    <stop offset="0.328" stopColor="#FF543F" />
                    <stop offset="0.348" stopColor="#FC5245" />
                    <stop offset="0.504" stopColor="#E64771" />
                    <stop offset="0.643" stopColor="#D53E91" />
                    <stop offset="0.761" stopColor="#CC39A4" />
                    <stop offset="0.841" stopColor="#C837AB" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_6352_38260"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(4.57884 0.447462) rotate(-0.318914) scale(12.0094 8.00185)"
                >
                    <stop stopColor="#4168C9" />
                    <stop offset="0.999" stopColor="#4168C9" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
};

export const SocialMediaCaptionsIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32.526 3a7.397 7.397 0 1 0 0 14.794 7.397 7.397 0 0 0 0-14.794Z"
                fill="#E8E8E8"
            />
            <path
                d="M33.578 12.32h1.95l.307-1.957h-2.257v-1.07c0-.813.27-1.534 1.039-1.534h1.237V6.05c-.217-.029-.677-.092-1.546-.092-1.813 0-2.877.946-2.877 3.103v1.302h-1.865v1.958h1.865v5.381c.37.054.743.092 1.127.092.347 0 .686-.032 1.02-.076V12.32ZM14.617 18.08l-8.057.053a3.232 3.232 0 0 1-3.243-3.202l-.053-8.056a3.232 3.232 0 0 1 3.201-3.244l8.057-.052a3.232 3.232 0 0 1 3.243 3.201l.053 8.056a3.231 3.231 0 0 1-3.201 3.244Z"
                fill="#C1C1C1"
            />
            <path
                d="m14.617 18.08-8.057.053a3.232 3.232 0 0 1-3.243-3.202l-.053-8.056a3.232 3.232 0 0 1 3.201-3.244l8.057-.052a3.232 3.232 0 0 1 3.243 3.201l.053 8.056a3.231 3.231 0 0 1-3.201 3.244Z"
                fill="#E8E8E8"
            />
            <path
                d="M10.558 13.675a2.823 2.823 0 0 1-2.835-2.804 2.823 2.823 0 0 1 2.804-2.835 2.823 2.823 0 0 1 2.835 2.804 2.823 2.823 0 0 1-2.804 2.835Zm-.027-4.833a2.016 2.016 0 0 0-2.003 2.025 2.016 2.016 0 0 0 2.026 2.003 2.016 2.016 0 0 0 2.002-2.025 2.016 2.016 0 0 0-2.025-2.003ZM13.549 8.422a.604.604 0 1 0-.007-1.208.604.604 0 0 0 .007 1.208Z"
                fill="#C1C1C1"
            />
            <path
                d="m12.987 16.08-4.834.026a2.823 2.823 0 0 1-2.835-2.804l-.027-4.834a2.823 2.823 0 0 1 2.804-2.835l4.834-.027a2.823 2.823 0 0 1 2.835 2.804l.027 4.834a2.823 2.823 0 0 1-2.804 2.835ZM8.1 6.437a2.016 2.016 0 0 0-2.003 2.026l.027 4.833A2.017 2.017 0 0 0 8.149 15.3l4.834-.027a2.016 2.016 0 0 0 2.003-2.025l-.027-4.834a2.016 2.016 0 0 0-2.026-2.003L8.1 6.438ZM40.28 28.598a5.866 5.866 0 0 1-1.654.45 2.86 2.86 0 0 0 1.267-1.571 5.803 5.803 0 0 1-1.83.687 2.884 2.884 0 0 0-2.097-.894c-1.59 0-2.879 1.27-2.879 2.833 0 .222.026.437.075.647a8.221 8.221 0 0 1-5.932-2.962c-.249.418-.39.909-.39 1.426 0 .983.508 1.85 1.28 2.36a2.947 2.947 0 0 1-1.304-.355v.034c0 1.374.992 2.518 2.308 2.779a2.88 2.88 0 0 1-1.299.05 2.881 2.881 0 0 0 2.688 1.968 5.841 5.841 0 0 1-4.261 1.172 8.267 8.267 0 0 0 4.412 1.271c5.294 0 8.19-4.317 8.19-8.062 0-.123-.004-.245-.01-.366a5.64 5.64 0 0 0 1.437-1.468Z"
                fill="#C1C1C1"
            />
            <circle
                cx={10.395}
                cy={32.597}
                r={7.671}
                transform="rotate(15 10.395 32.597)"
                fill="#E8E8E8"
            />
            <path
                d="M7.566 31.238H9.08v4.87H7.566v-4.87Zm.756-2.424a.877.877 0 1 1-.003 1.754.877.877 0 0 1 .003-1.755Zm1.703 2.424h1.45v.665h.02c.202-.383.695-.786 1.433-.786 1.53 0 1.812 1.009 1.812 2.32v2.671h-1.51V33.74c0-.564-.01-1.292-.785-1.292-.787 0-.908.616-.908 1.25v2.41h-1.51v-4.87h-.002Z"
                fill="#C1C1C1"
            />
        </svg>
    );
};

export const RewriteParagraphIcon = () => {
    return (
        <svg
            width={43}
            height={38}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m41.957 18.548.385.532h-2.32l-4.577-.532m6.512 0h.657l-4.552-6.29-.329.454m4.224 5.836H35.445m6.512 0-4.224-5.836m0 0-.328-.454-4.553 6.29h.658m4.223-5.836-4.223 5.836m0 0-.386.532h2.321v-.532m-1.935 0h1.935m3.504 1.065h.532-.532Zm0 0c-.272 9.524-7.802 17.127-17.015 17.127a16.482 16.482 0 0 1-8.848-2.577l1.82-1.886a14.078 14.078 0 0 0 7.028 1.89c7.883 0 14.296-6.498 14.567-14.554h2.448ZM21.934 1.42c3.125-.003 6.187.89 8.848 2.578l-1.82 1.886a14.077 14.077 0 0 0-7.028-1.89c-7.882 0-14.295 6.497-14.567 14.554H4.92C5.192 9.024 12.722 1.42 21.934 1.42ZM6.135 25.45l-4.223-5.836h8.447l-4.224 5.836Z"
                fill="#4596F6"
                stroke="#fff"
                strokeWidth={1.065}
            />
            <rect
                x={14.956}
                y={10.951}
                width={15.094}
                height={17.106}
                rx={1.534}
                fill="#4596F6"
            />
            <path
                d="M17.732 14.977h9.33M17.732 17.995h6.786M17.732 21.014h9.33M17.732 24.032h6.786"
                stroke="#fff"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const RewriteParagraphIconDisabled = () => {
    return (
        <svg
            width={43}
            height={38}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m41.957 18.548.385.532h-2.32l-4.577-.532m6.512 0h.657l-4.552-6.29-.329.454m4.224 5.836H35.445m6.512 0-4.224-5.836m0 0-.328-.454-4.553 6.29h.658m4.223-5.836-4.223 5.836m0 0-.386.532h2.321v-.532m-1.935 0h1.935m3.504 1.065h.532-.532Zm0 0c-.272 9.524-7.802 17.127-17.015 17.127a16.482 16.482 0 0 1-8.848-2.577l1.82-1.886a14.078 14.078 0 0 0 7.028 1.89c7.883 0 14.296-6.498 14.567-14.554h2.448ZM21.934 1.42c3.125-.003 6.187.89 8.848 2.578l-1.82 1.886a14.077 14.077 0 0 0-7.028-1.89c-7.882 0-14.295 6.497-14.567 14.554H4.92C5.192 9.024 12.722 1.42 21.934 1.42ZM6.135 25.45l-4.223-5.836h8.447l-4.224 5.836Z"
                fill="#C1C1C1"
                stroke="#EAEAEA"
                strokeWidth={1.065}
            />
            <rect
                x={14.957}
                y={10.951}
                width={15.094}
                height={17.106}
                rx={1.534}
                fill="#C1C1C1"
            />
            <path
                d="M17.734 14.977h9.33M17.734 17.995h6.786M17.734 21.014h9.33M17.734 24.032h6.786"
                stroke="#EAEAEA"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PropertyVideosIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="#ECFCFF" />
            <path
                d="M32.904 23.306a1 1 0 0 0 0-1.612L18.592 11.171a1 1 0 0 0-1.592.806v21.046a1 1 0 0 0 1.592.806l14.312-10.523Z"
                fill="#6EDCF3"
            />
        </svg>
    );
};

export const PropertyVideosIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="#E8E8E8" />
            <path
                d="M32.904 23.306a1 1 0 0 0 0-1.612L18.592 11.171a1 1 0 0 0-1.592.806v21.046a1 1 0 0 0 1.592.806l14.312-10.523Z"
                fill="#C1C1C1"
            />
        </svg>
    );
};

export const DigitalFlyersIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="#FFF7F7" />
            <path d="m9 26 7.5-13L24 26H9Z" fill="#FFC4C4" />
            <path d="m16 26 9.5-16L35 26H16Z" fill="#F87B7B" />
            <path
                d="M11.74 31.367h18.254c.63 0 1.141-.418 1.141-.934 0-.515-.511-.933-1.141-.933H11.739c-.631 0-1.141.418-1.141.933 0 .516.51.934 1.141.934Z"
                fill="#FFC4C4"
            />
            <path
                d="M11.74 36.039h18.254c.63 0 1.141-.418 1.141-.934 0-.515-.511-.933-1.141-.933H11.739c-.631 0-1.141.418-1.141.933 0 .516.51.934 1.141.934Z"
                fill="#F87B7B"
            />
        </svg>
    );
};

export const DigitalFlyersIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#a)">
                <circle
                    cx={18.5}
                    cy={22.5}
                    r={22.5}
                    fill="#9AFF04"
                    fillOpacity={0.16}
                />
                <path
                    d="M53 46.3c0 .938-.56 1.7-1.249 1.7h-57.5C-6.44 48-7 47.238-7 46.3V-1.3c0-.938.56-1.7 1.25-1.7h57.501C52.44-3 53-2.238 53-1.3v47.6Z"
                    fill="#E8E8E8"
                />
                <path d="m10 24 7.5-13L25 24H10Z" fill="#DADADA" />
                <path d="m17 24 9.5-16L36 24H17Z" fill="#C1C1C1" />
                <path
                    d="M12.74 29.37h18.254c.63 0 1.141-.417 1.141-.933 0-.515-.511-.933-1.141-.933H12.739c-.631 0-1.141.418-1.141.933 0 .516.51.934 1.141.934Z"
                    fill="#DADADA"
                />
                <path
                    d="M12.74 34.039h18.254c.63 0 1.141-.418 1.141-.934 0-.515-.511-.933-1.141-.933H12.739c-.631 0-1.141.418-1.141.933 0 .516.51.934 1.141.934Z"
                    fill="#C1C1C1"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <rect width={45} height={45} rx={22.5} fill="#fff" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const AgentsBioIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2695_21580)">
                <path
                    d="M53 46.2992C53 47.2382 52.4396 48 51.7512 48H-5.74944C-6.43971 48 -7 47.2382 -7 46.2992V-1.29923C-7 -2.23801 -6.43971 -3 -5.74944 -3H51.7512C52.4396 -3 53 -2.23801 53 -1.29923V46.2992Z"
                    fill="#FF8832"
                    fillOpacity={0.06}
                />
                <path
                    d="M16 24C18.7614 24 21 21.7614 21 19C21 16.2386 18.7614 14 16 14C13.2386 14 11 16.2386 11 19C11 21.7614 13.2386 24 16 24Z"
                    fill="#FF8832"
                    stroke="#FF8832"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 17H37"
                    stroke="#FF8832"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 23H37"
                    stroke="#FF8832"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28 29H37"
                    stroke="#FF8832"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 32C8.45482 29.7115 9.4879 27.6832 10.9364 26.2347C12.3849 24.7862 14.1664 24 16 24C17.8336 24 19.6151 24.7862 21.0636 26.2347C22.5121 27.6832 23.5452 29.7115 24 32"
                    fill="#FF8832"
                />
            </g>
            <defs>
                <clipPath id="clip0_2695_21580">
                    <rect width={45} height={45} rx={22.5} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const AgentsBioIconDisabled = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2953_22646)">
                <path
                    d="M53 46.2992C53 47.2382 52.4396 48 51.7512 48H-5.74944C-6.43971 48 -7 47.2382 -7 46.2992V-1.29923C-7 -2.23801 -6.43971 -3 -5.74944 -3H51.7512C52.4396 -3 53 -2.23801 53 -1.29923V46.2992Z"
                    fill="#C1C1C1"
                    fillOpacity={0.06}
                />
                <path
                    d="M16 24C18.7614 24 21 21.7614 21 19C21 16.2386 18.7614 14 16 14C13.2386 14 11 16.2386 11 19C11 21.7614 13.2386 24 16 24Z"
                    fill="#C1C1C1"
                    stroke="#C1C1C1"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 17H37"
                    stroke="#C1C1C1"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25 23H37"
                    stroke="#C1C1C1"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28 29H37"
                    stroke="#C1C1C1"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8 32C8.45482 29.7115 9.4879 27.6832 10.9364 26.2347C12.3849 24.7862 14.1664 24 16 24C17.8336 24 19.6151 24.7862 21.0636 26.2347C22.5121 27.6832 23.5452 29.7115 24 32"
                    fill="#C1C1C1"
                />
            </g>
            <defs>
                <clipPath id="clip0_2953_22646">
                    <rect width={45} height={45} rx={22.5} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const StepperCheckIcon = () => {
    return (
        <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.1875 1L4.0625 7.125L1 4.0625"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ExhaustedFtPropDesIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx={22.5}
                cy={22.5}
                r={22.5}
                fill="#9AFF04"
                fillOpacity={0.16}
            />
            <path
                d="M13.439 9.08155C12.5504 9.28274 11.7214 9.96886 11.3193 10.8355C10.9718 11.5784 10.9917 10.9026 11.0066 22.1848L11.0215 32.3475L11.1605 32.755C11.3392 33.2864 11.498 33.5598 11.8555 33.9519C12.2278 34.3697 12.605 34.6225 13.1312 34.8185L13.5532 34.9785L17.6634 34.9939C22.1807 35.0094 21.9971 35.0197 22.1807 34.6999C22.3396 34.4213 22.2502 34.0035 22.002 33.859C21.9176 33.8074 20.9943 33.7868 17.7975 33.7662C13.7368 33.7404 13.7021 33.7404 13.439 33.6269C12.9327 33.4102 12.5306 32.9923 12.3221 32.4661L12.2129 32.1927L12.198 22.159C12.188 14.6117 12.198 12.053 12.2427 11.8415C12.3717 11.207 12.754 10.7117 13.3298 10.428L13.6524 10.2681H22.7119H31.7713L32.094 10.428C32.4862 10.6189 32.7294 10.8355 32.928 11.1605C33.2457 11.6712 33.2357 11.5526 33.2357 16.0665C33.2357 20.0748 33.2407 20.178 33.335 20.3431C33.5435 20.699 33.9804 20.7506 34.2583 20.4514L34.4023 20.2967L34.4172 16.1078C34.4321 11.3978 34.442 11.5165 34.0697 10.753C33.6726 9.92759 32.8485 9.27243 31.9699 9.08155C31.4685 8.97322 13.9205 8.97322 13.439 9.08155Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
            <path
                d="M16.4718 14.6275C16.0896 14.7204 15.901 15.1382 16.0797 15.4993C16.2484 15.8398 15.7719 15.814 22.5429 15.814H28.6785L28.8473 15.6386C28.9912 15.489 29.0161 15.4271 29.0161 15.2259C29.0161 14.9267 28.8374 14.6946 28.5445 14.6275C28.3062 14.5707 16.7051 14.5707 16.4718 14.6275Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
            <path
                d="M16.2752 19.5275C16.0964 19.6358 15.9773 19.9505 16.0269 20.1569C16.0816 20.3632 16.2553 20.5541 16.4489 20.6108C16.6971 20.6779 25.3991 20.6831 25.6473 20.6108C26.1189 20.4715 26.2579 19.8783 25.8856 19.5585L25.7317 19.4243H21.0853C16.5631 19.4243 16.429 19.4295 16.2752 19.5275Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
            <path
                d="M32.7231 22.2106C32.5096 22.2674 32.187 22.4324 31.9785 22.5924C31.77 22.7471 31.4672 23.2114 31.3729 23.5055L31.2934 23.7531L30.8665 23.3713C30.6382 23.1598 30.3205 22.9225 30.1666 22.8451C29.9085 22.711 29.834 22.7007 29.3376 22.7007C28.4838 22.7007 28.598 22.6233 25.4904 25.4606C24.031 26.7916 22.7949 27.9471 22.7503 28.0245C22.5567 28.3444 22.7056 28.8035 23.0332 28.917C23.197 28.9737 23.3261 28.9634 23.5247 28.886C23.5942 28.8602 23.6041 29.113 23.614 31.2745C23.6289 33.6321 23.6339 33.694 23.7381 33.9313C23.887 34.2718 24.2593 34.669 24.5919 34.8341L24.8699 34.9785H29.3128H33.7556L34.0535 34.8341C34.4307 34.6535 34.7782 34.2666 34.9321 33.8797C35.0413 33.5908 35.0463 33.5444 35.0612 31.2333L35.0761 28.8809L35.2697 28.9376C35.6569 29.0408 36.0441 28.69 35.9944 28.2721C35.9746 28.0916 35.92 28.0142 35.5228 27.6273L35.0711 27.1888V25.667C35.0711 24.8313 35.0513 24.0059 35.0215 23.8408C34.8775 22.9122 34.1577 22.2313 33.2741 22.1848C33.0756 22.1693 32.8273 22.1848 32.7231 22.2106ZM33.5174 23.5003C33.84 23.7015 33.8549 23.7634 33.8698 24.9912C33.8847 26.0848 33.8847 26.0952 33.7904 26.0229C33.7358 25.9817 33.4081 25.6928 33.0656 25.3832L32.4352 24.8158L32.455 24.3463C32.4699 23.8253 32.5345 23.6654 32.8025 23.5003C32.8919 23.4436 33.0507 23.3971 33.1599 23.3971C33.2692 23.3971 33.428 23.4436 33.5174 23.5003ZM29.695 23.9801C29.7546 24.0162 30.7176 24.8777 31.8395 25.8991L33.8748 27.7563L33.8797 30.5059C33.8797 33.5186 33.8797 33.5289 33.5869 33.6837C33.4677 33.7507 33.2543 33.7662 32.4948 33.7662H31.5565L31.5367 32.7706L31.5218 31.7801L31.3629 31.4345C30.9658 30.5575 30.1616 30.0932 29.1837 30.1706C28.3349 30.2376 27.6597 30.7432 27.3371 31.5583C27.2179 31.8575 27.208 31.9555 27.1882 32.8273L27.1683 33.7714L26.1258 33.7559L25.0834 33.7404L24.9394 33.5702L24.7955 33.4051V30.5781V27.7511L26.7662 25.9455C27.8484 24.9551 28.8164 24.0936 28.9107 24.0317C29.1142 23.8975 29.5113 23.8717 29.695 23.9801ZM29.7993 31.4706C29.8985 31.517 30.0326 31.6047 30.0971 31.6666C30.3304 31.8936 30.3552 32.0071 30.3552 32.915V33.7662H29.3575H28.3597L28.3795 32.9253C28.3944 32.1567 28.4044 32.0741 28.5086 31.8833C28.6377 31.6614 28.7568 31.5531 28.9901 31.4603C29.2036 31.3726 29.5858 31.3777 29.7993 31.4706Z"
                fill="#67A110"
            />
            <path
                d="M28.6837 25.5171C28.3313 25.6616 27.9143 26.0639 27.7406 26.4302C27.6165 26.6881 27.6016 26.781 27.6016 27.2143C27.6016 27.6064 27.6214 27.7508 27.7108 27.9469C27.8498 28.2667 28.237 28.6897 28.5199 28.8393C29.2099 29.2005 30.0935 29.0509 30.5949 28.4834C30.858 28.1842 30.9821 27.9211 31.0566 27.5084C31.1062 27.2195 31.1062 27.1163 31.0367 26.8223C30.8977 26.2342 30.6048 25.8524 30.0886 25.579C29.7361 25.3881 29.066 25.3572 28.6837 25.5171ZM29.6765 26.7552C29.8701 26.91 29.9396 27.1937 29.8453 27.431C29.6815 27.8334 29.2397 27.9211 28.9369 27.6064C28.7979 27.462 28.7681 27.3897 28.7681 27.2143C28.7681 27.0389 28.7979 26.9667 28.9369 26.8223C29.0809 26.6727 29.1404 26.6469 29.3291 26.6469C29.478 26.6469 29.5922 26.683 29.6765 26.7552Z"
                fill="#67A110"
            />
            <path
                d="M16.2752 24.3263C16.0964 24.4346 15.9773 24.7493 16.0269 24.9557C16.0816 25.162 16.2553 25.3529 16.4489 25.4096C16.7467 25.4922 20.2464 25.4767 20.4499 25.389C20.6932 25.2858 20.8272 25.0795 20.8272 24.8061C20.8272 24.61 20.8024 24.5481 20.6584 24.3985L20.4897 24.2231H18.4593C16.5383 24.2231 16.4241 24.2283 16.2752 24.3263Z"
                fill="#67A110"
                stroke="#67A110"
                strokeWidth={0.5}
            />
        </svg>
    );
};

export const ExhaustedFtPropVideoIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="#ECFCFF" />
            <path
                d="M32.9043 23.3057C33.4478 22.906 33.4478 22.094 32.9043 21.6943L18.5924 11.1709C17.932 10.6853 17 11.1568 17 11.9765V33.0235C17 33.8432 17.932 34.3147 18.5924 33.8291L32.9043 23.3057Z"
                fill="#6EDCF3"
            />
        </svg>
    );
};

export const ExhaustedFtRewriteContIcon = () => {
    return (
        <svg
            width={43}
            height={38}
            viewBox="0 0 43 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M41.9547 18.5478L42.3402 19.0804H40.0194L35.4433 18.5478M41.9547 18.5478H42.6122L38.06 12.2576L37.7313 12.7118M41.9547 18.5478H40.0194H39.4868H35.9759H35.4433M41.9547 18.5478L37.7313 12.7118M37.7313 12.7118L37.4026 12.2576L32.8505 18.5478H33.5079M37.7313 12.7118L33.5079 18.5478M33.5079 18.5478L33.1225 19.0804H35.4433V18.5478M33.5079 18.5478H35.4433M38.9466 19.613H39.4794H38.9466ZM38.9466 19.613C38.675 29.1372 31.1447 36.7405 21.9324 36.7405H21.9319C18.8073 36.7436 15.7458 35.85 13.0846 34.1628L14.904 32.2772C16.9883 33.4723 19.3802 34.1671 21.9324 34.1671C29.8146 34.1671 36.2277 27.6695 36.4995 19.613H38.9466ZM21.9324 1.42031L21.9329 1.42031C25.0575 1.41715 28.119 2.3108 30.7802 3.99798L28.9608 5.8836C26.8765 4.68844 24.4846 3.99363 21.9324 3.99363C14.0502 3.99363 7.63709 10.4912 7.36529 18.5478H4.91825C5.1898 9.02359 12.7202 1.42031 21.9324 1.42031ZM6.13349 25.449L1.91007 19.613H3.84545H4.37806H7.88893H8.42154H10.3569L6.13349 25.449Z"
                fill="#4596F6"
                stroke="white"
                strokeWidth={1.06522}
            />
            <rect
                x={14.9531}
                y={10.9512}
                width={15.0935}
                height={17.1059}
                rx={1.53391}
                fill="#4596F6"
            />
            <path
                d="M17.7305 14.9766H27.0606"
                stroke="white"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7305 17.9951H24.516"
                stroke="white"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7305 21.0137H27.0606"
                stroke="white"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7305 24.0322H24.516"
                stroke="white"
                strokeWidth={0.7}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ExhaustedFtDigitalFlyersIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8205_35786)">
                <circle
                    cx={18.5}
                    cy={22.5}
                    r={22.5}
                    fill="#9AFF04"
                    fillOpacity={0.16}
                />
                <path
                    d="M53 46.2992C53 47.2382 52.4396 48 51.7512 48H-5.74944C-6.43971 48 -7 47.2382 -7 46.2992V-1.29923C-7 -2.23801 -6.43971 -3 -5.74944 -3H51.7512C52.4396 -3 53 -2.23801 53 -1.29923V46.2992Z"
                    fill="#FFF7F7"
                />
                <path d="M10 24L17.4993 11L25 24H10Z" fill="#FFC4C4" />
                <path d="M17 24L26.5001 8L36 24H17Z" fill="#F87B7B" />
                <path
                    d="M12.7392 29.3709H30.9936C31.6236 29.3709 32.1351 28.9528 32.1351 28.4374C32.1351 27.9221 31.6236 27.5039 30.9936 27.5039H12.7392C12.1076 27.5039 11.5977 27.9221 11.5977 28.4374C11.5977 28.9528 12.1076 29.3709 12.7392 29.3709Z"
                    fill="#FFC4C4"
                />
                <path
                    d="M12.7392 34.0389H30.9936C31.6236 34.0389 32.1351 33.6208 32.1351 33.1054C32.1351 32.59 31.6236 32.1719 30.9936 32.1719H12.7392C12.1076 32.1719 11.5977 32.59 11.5977 33.1054C11.5977 33.6208 12.1076 34.0389 12.7392 34.0389Z"
                    fill="#F87B7B"
                />
            </g>
            <defs>
                <clipPath id="clip0_8205_35786">
                    <rect width={45} height={45} rx={22.5} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ExhaustedFtMarketingEmailIcon = () => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={22.5} cy={22.5} r={22.5} fill="white" />
            <path
                d="M30.4753 13.5537L22.5837 19.7124L14.5117 13.5537V13.5554L14.5215 13.5637V22.1876L22.4927 28.4794L30.4753 22.4305V13.5537Z"
                fill="#EA4335"
            />
            <path
                d="M32.549 12.0562L30.4766 13.5542V22.431L36.9978 17.4243V14.4081C36.9978 14.4081 36.2063 10.1004 32.549 12.0562Z"
                fill="#FBBC05"
            />
            <path
                d="M30.4766 22.4306V33.944H35.4748C35.4748 33.944 36.8971 33.7976 36.9994 32.1763V17.4238L30.4766 22.4306Z"
                fill="#34A853"
            />
            <path
                d="M14.5218 33.9545V22.188L14.5117 22.1797L14.5218 33.9545Z"
                fill="#C5221F"
            />
            <path
                d="M14.5116 13.5568L12.4505 12.0671C8.79322 10.1113 8 14.4174 8 14.4174V17.4334L14.5116 22.1806V13.5568Z"
                fill="#C5221F"
            />
            <path
                d="M14.5117 13.5557V22.1796L14.5218 22.1879V13.564L14.5117 13.5557Z"
                fill="#C5221F"
            />
            <path
                d="M8 17.4346V32.1871C8.10078 33.8101 9.52468 33.9549 9.52468 33.9549H14.5229L14.5116 22.1801L8 17.4346Z"
                fill="#4285F4"
            />
        </svg>
    );
};

export const ExhaustedFtSocialMediaIcon = () => {
    return (
        <svg
            width={43}
            height={43}
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M31.0802 2.86719C27.1763 2.86719 24.0117 6.03174 24.0117 9.93566C24.0117 13.8396 27.1763 17.0041 31.0802 17.0041C34.9841 17.0041 38.1487 13.8396 38.1487 9.93566C38.1487 6.03174 34.9841 2.86719 31.0802 2.86719Z"
                fill="url(#paint0_linear_8205_35754)"
            />
            <path
                d="M32.0874 11.7733H33.951L34.2437 9.9026H32.0874V8.88009C32.0874 8.10306 32.3445 7.41392 33.0801 7.41392H34.2621V5.78159C34.0544 5.75384 33.6151 5.69336 32.7852 5.69336C31.0519 5.69336 30.0358 6.59775 30.0358 8.65844V9.90296H28.2539V11.7737H30.0354V16.9154C30.3883 16.9673 30.7458 17.0029 31.1127 17.0029C31.4443 17.0029 31.768 16.973 32.0874 16.9303V11.7733Z"
                fill="white"
            />
            <path
                d="M13.9667 17.2764L6.26844 17.3265C4.57483 17.3375 3.18028 15.9611 3.16892 14.2674L3.11876 6.5692C3.10779 4.87559 4.48423 3.48104 6.17784 3.46968L13.8761 3.41952C15.5697 3.40855 16.9642 4.78499 16.9756 6.4786L17.0258 14.1768C17.0371 15.8708 15.6603 17.2654 13.9667 17.2764Z"
                fill="url(#paint1_radial_8205_35754)"
            />
            <path
                d="M13.9667 17.2764L6.26844 17.3265C4.57483 17.3375 3.18028 15.9611 3.16892 14.2674L3.11876 6.5692C3.10779 4.87559 4.48423 3.48104 6.17784 3.46968L13.8761 3.41952C15.5697 3.40855 16.9642 4.78499 16.9756 6.4786L17.0258 14.1768C17.0371 15.8708 15.6603 17.2654 13.9667 17.2764Z"
                fill="url(#paint2_radial_8205_35754)"
            />
            <path
                d="M10.0877 13.0662C8.60229 13.0745 7.38655 11.8726 7.37828 10.3868C7.37001 8.90101 8.5723 7.68565 10.0577 7.67739C11.5431 7.66912 12.7588 8.87102 12.7671 10.3568C12.7753 11.8426 11.5731 13.0579 10.0877 13.0662ZM10.062 8.44721C9.00076 8.45312 8.1422 9.32129 8.14811 10.3825C8.15401 11.4437 9.02218 12.3023 10.0834 12.2964C11.1446 12.2904 12.0032 11.4223 11.9972 10.3611C11.9913 9.29986 11.1232 8.44131 10.062 8.44721Z"
                fill="white"
            />
            <path
                d="M12.9471 8.04704C13.266 8.04526 13.523 7.78533 13.5212 7.46645C13.5195 7.14758 13.2595 6.89052 12.9407 6.89229C12.6218 6.89407 12.3647 7.15401 12.3665 7.47288C12.3683 7.79175 12.6282 8.04881 12.9471 8.04704Z"
                fill="white"
            />
            <path
                d="M12.4081 15.3645L7.78917 15.3902C6.30378 15.3985 5.08804 14.1966 5.07977 12.7108L5.05406 8.09186C5.04579 6.60609 6.24808 5.39073 7.73346 5.38246L12.3524 5.35675C13.8378 5.34849 15.0536 6.55039 15.0618 8.03616L15.0875 12.6551C15.0958 14.1409 13.8935 15.3563 12.4081 15.3645ZM7.73775 6.15229C6.67654 6.1582 5.81798 7.02637 5.82389 8.08758L5.8496 12.7065C5.85551 13.7678 6.72367 14.6263 7.78488 14.6204L12.4039 14.5947C13.4651 14.5888 14.3236 13.7206 14.3177 12.6594L14.292 8.04044C14.2861 6.97923 13.4179 6.12068 12.3567 6.12658L7.73775 6.15229Z"
                fill="white"
            />
            <path
                d="M38.4872 27.3257C37.9946 27.5424 37.4648 27.6869 36.9059 27.7554C37.4741 27.4203 37.9112 26.886 38.1164 26.2547C37.5847 26.5642 36.9956 26.7917 36.369 26.9115C35.8686 26.3845 35.1548 26.0576 34.364 26.0576C32.8449 26.0576 31.6135 27.2698 31.6135 28.7645C31.6135 28.9761 31.6385 29.182 31.6854 29.3821C29.4 29.2682 27.373 28.1891 26.017 26.5517C25.7787 26.9518 25.6446 27.4203 25.6446 27.9147C25.6446 28.8544 26.129 29.6816 26.8678 30.169C26.4169 30.1554 25.9924 30.0307 25.6208 29.831C25.6208 29.8392 25.6208 29.8514 25.6208 29.8628C25.6208 31.176 26.5691 32.2695 27.8261 32.5184C27.5964 32.5809 27.3536 32.6156 27.1034 32.6156C26.9258 32.6156 26.7527 32.5957 26.5851 32.5657C26.9351 33.6389 27.9505 34.4232 29.1535 34.4465C28.2123 35.1713 27.0267 35.6054 25.7377 35.6054C25.5151 35.6054 25.2972 35.5929 25.082 35.567C26.2999 36.3328 27.7461 36.7818 29.2984 36.7818C34.3565 36.7818 37.1237 32.6563 37.1237 29.0774C37.1237 28.9602 37.12 28.8433 37.1144 28.7279C37.6543 28.3493 38.1197 27.8715 38.4872 27.3257Z"
                fill="#03A9F4"
            />
            <circle
                cx={9.92902}
                cy={31.148}
                r={7.32977}
                transform="rotate(15 9.92902 31.148)"
                fill="#0177B5"
            />
            <path
                d="M7.22859 29.8496L8.67531 29.8496L8.67531 34.5036L7.22859 34.5036L7.22859 29.8496ZM7.95088 27.5332C8.41243 27.5332 8.78758 27.909 8.78758 28.3714C8.78758 28.8337 8.41243 29.2104 7.95119 29.2104C7.72916 29.2099 7.51636 29.1214 7.35934 28.9642C7.20231 28.8069 7.11384 28.5938 7.11328 28.3714C7.11328 28.2612 7.13495 28.1521 7.17706 28.0504C7.21916 27.9486 7.28087 27.8562 7.35866 27.7784C7.43646 27.7005 7.5288 27.6388 7.63042 27.5967C7.73203 27.5547 7.84093 27.5331 7.95088 27.5332ZM9.57863 29.8496L10.9636 29.8496L10.9636 30.4856L10.9827 30.4856C11.1756 30.1199 11.6466 29.734 12.3519 29.734C13.8141 29.734 14.084 30.6981 14.084 31.951L14.084 34.5039L12.6409 34.5039L12.6409 32.24C12.6409 31.7005 12.6312 31.0056 11.8906 31.0056C11.1391 31.0056 11.0235 31.5938 11.0235 32.2003L11.0235 34.5027L9.58076 34.5027L9.58076 29.8486L9.57863 29.8496Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_8205_35754"
                    x1={26.1298}
                    y1={4.98526}
                    x2={36.9523}
                    y2={15.8078}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2AA4F4" />
                    <stop offset={1} stopColor="#007AD9" />
                </linearGradient>
                <radialGradient
                    id="paint1_radial_8205_35754"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.33279 17.325) rotate(-0.318914) scale(17.2825 17.2825)"
                >
                    <stop stopColor="#FFDD55" />
                    <stop offset={0.328} stopColor="#FF543F" />
                    <stop offset={0.348} stopColor="#FC5245" />
                    <stop offset={0.504} stopColor="#E64771" />
                    <stop offset={0.643} stopColor="#D53E91" />
                    <stop offset={0.761} stopColor="#CC39A4" />
                    <stop offset={0.841} stopColor="#C837AB" />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_8205_35754"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(5.33156 3.29398) rotate(-0.318914) scale(11.4756 7.64621)"
                >
                    <stop stopColor="#4168C9" />
                    <stop offset={0.999} stopColor="#4168C9" stopOpacity={0} />
                </radialGradient>
            </defs>
        </svg>
    );
};

export const CircleCheckIcon = () => {
    return (
        <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.1094 8.76562L9.29414 13.3594L6.89062 11.0625"
                stroke="#67A110"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 18.6094C14.8492 18.6094 18.375 15.0836 18.375 10.7344C18.375 6.38513 14.8492 2.85938 10.5 2.85938C6.15076 2.85938 2.625 6.38513 2.625 10.7344C2.625 15.0836 6.15076 18.6094 10.5 18.6094Z"
                stroke="#E0FFB3"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CircleCloseIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                stroke="black"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M20 12L12 20"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 20L12 12"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const RightArrowIcon = () => {
    return (
        <svg
            width={28}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27.53 6.53a.75.75 0 0 0 0-1.06L22.757.697a.75.75 0 0 0-1.06 1.06L25.939 6l-4.242 4.243a.75.75 0 0 0 1.06 1.06L27.53 6.53ZM0 6.75h27v-1.5H0v1.5Z"
                fill="#67A110"
            />
        </svg>
    );
};

export const LockIconDisabled = () => {
    return (
        <svg
            width={27}
            height={33}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.95 8.25v4.95c2.025 0 4.05 1.98 4.05 4.29v11.55c0 1.98-2.025 3.96-4.387 3.96H4.05C2.025 33 0 31.02 0 28.71V17.16c0-1.98 2.025-3.96 4.05-3.96V8.25C4.05 3.63 8.775 0 13.5 0s9.45 3.63 9.45 8.25Z"
                fill="#B3B3B3"
            />
            <path
                d="M8.438 13.197h10.124v-4.95c0-2.64-2.362-4.29-5.062-4.29s-5.063 1.65-5.063 4.29v4.95Z"
                fill="#E7E7E7"
            />
        </svg>
    );
};

export const GenSectionNotFoundIcon = () => {
    return (
        <svg
            width={150}
            height={145}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M75.51 144.039c37.157 0 67.278-29.929 67.278-66.85 0-36.92-30.121-66.849-67.278-66.849-37.156 0-67.278 29.93-67.278 66.85 0 36.92 30.122 66.849 67.278 66.849Z"
                fill="url(#a)"
            />
            <path
                d="M111.804 25.893h-74.53c-4.645 0-8.41 3.741-8.41 8.358h91.352c0-4.616-3.766-8.358-8.412-8.358Z"
                fill="url(#b)"
            />
            <path
                d="M28.863 34.022h91.353v69.133c0 3.073-1.229 6.021-3.416 8.194a11.701 11.701 0 0 1-8.248 3.395H40.527a11.7 11.7 0 0 1-8.248-3.395 11.55 11.55 0 0 1-3.416-8.194V34.022Z"
                fill="url(#c)"
            />
            <path
                d="M104.514 42.756H44.597a2.251 2.251 0 0 0-2.26 2.242 2.251 2.251 0 0 0 2.26 2.243h59.917a2.251 2.251 0 0 0 2.26-2.243 2.251 2.251 0 0 0-2.26-2.242Z"
                fill="url(#d)"
            />
            <path
                d="M104.514 61.813H44.597a2.251 2.251 0 0 0-2.26 2.242 2.251 2.251 0 0 0 2.26 2.243h59.917a2.251 2.251 0 0 0 2.26-2.243 2.251 2.251 0 0 0-2.26-2.243Z"
                fill="url(#e)"
            />
            <path
                d="M104.514 80.866H44.597a2.251 2.251 0 0 0-2.26 2.243 2.251 2.251 0 0 0 2.26 2.242h59.917a2.251 2.251 0 0 0 2.26-2.242 2.251 2.251 0 0 0-2.26-2.243Z"
                fill="url(#f)"
            />
            <path
                d="M104.514 99.923H44.597a2.25 2.25 0 0 0-2.26 2.243 2.25 2.25 0 0 0 2.26 2.242h59.917a2.251 2.251 0 0 0 2.26-2.242 2.251 2.251 0 0 0-2.26-2.243Z"
                fill="url(#g)"
            />
            <g filter="url(#h)">
                <path
                    d="M44.192 76.78H12.288c-2.564 0-4.642 2.064-4.642 4.611v45.313c0 2.547 2.078 4.611 4.641 4.611h31.905c2.564 0 4.641-2.064 4.641-4.611V81.391c0-2.547-2.077-4.611-4.64-4.611Z"
                    fill="url(#i)"
                />
            </g>
            <g filter="url(#j)">
                <path
                    d="M135.016 6h-35.24a2.964 2.964 0 0 0-2.973 2.954v16.459a2.964 2.964 0 0 0 2.973 2.954h35.24a2.965 2.965 0 0 0 2.974-2.954V8.954A2.965 2.965 0 0 0 135.016 6Z"
                    fill="url(#k)"
                />
            </g>
            <path
                d="M40.632 99.448H15.847c-.835 0-1.511.672-1.511 1.501v.005c0 .829.676 1.502 1.511 1.502h24.785c.834 0 1.51-.673 1.51-1.502v-.005c0-.829-.676-1.501-1.51-1.501Z"
                fill="url(#l)"
            />
            <path
                d="M40.646 120.61H16.074c-.827 0-1.498.652-1.498 1.455v.005c0 .803.67 1.454 1.498 1.454h24.572c.827 0 1.498-.651 1.498-1.454v-.005c0-.803-.67-1.455-1.498-1.455Z"
                fill="url(#m)"
            />
            <path
                d="M40.646 109.54H16.074c-.827 0-1.498.651-1.498 1.454v.005c0 .803.67 1.455 1.498 1.455h24.572c.827 0 1.498-.652 1.498-1.455v-.005c0-.803-.67-1.454-1.498-1.454Z"
                fill="url(#n)"
            />
            <path
                d="M24.91 83.776h-7.243a2.896 2.896 0 0 0-2.905 2.887v1.997c0 1.594 1.3 2.886 2.905 2.886h7.242a2.896 2.896 0 0 0 2.905-2.886v-1.997c0-1.594-1.3-2.887-2.905-2.887Z"
                fill="url(#o)"
            />
            <path
                d="M105.5 20.58c1.888 0 3.419-1.521 3.419-3.397s-1.531-3.397-3.419-3.397c-1.888 0-3.418 1.52-3.418 3.397 0 1.876 1.53 3.396 3.418 3.396ZM117.717 20.58c1.888 0 3.419-1.521 3.419-3.397s-1.531-3.397-3.419-3.397c-1.888 0-3.418 1.52-3.418 3.397 0 1.876 1.53 3.396 3.418 3.396ZM129.932 20.58c1.888 0 3.418-1.521 3.418-3.397s-1.53-3.397-3.418-3.397c-1.888 0-3.418 1.52-3.418 3.397 0 1.876 1.53 3.396 3.418 3.396Z"
                fill="#81D5E7"
            />
            <g filter="url(#p)">
                <ellipse
                    cx={93.053}
                    cy={102.694}
                    rx={21.381}
                    ry={3.159}
                    fill="#EC5575"
                    fillOpacity={0.56}
                />
            </g>
            <path
                d="M68.344 123.673c.302-1.249 2.079-1.249 2.38 0l1.016 4.206c.108.446.456.795.903.903l4.205 1.015c1.25.302 1.25 2.079 0 2.381l-4.205 1.015a1.224 1.224 0 0 0-.903.903l-1.015 4.205c-.302 1.25-2.08 1.25-2.381 0l-1.015-4.205a1.224 1.224 0 0 0-.903-.903l-4.206-1.015c-1.25-.302-1.25-2.079 0-2.381l4.206-1.015c.446-.108.795-.457.903-.903l1.015-4.206Z"
                fill="url(#q)"
            />
            <path
                d="M19.97 11.773c.303-1.25 2.08-1.25 2.382 0l1.015 4.205c.107.447.456.796.903.903l4.205 1.016c1.25.301 1.25 2.079 0 2.38l-4.205 1.015a1.224 1.224 0 0 0-.903.903l-1.015 4.206c-.302 1.25-2.08 1.25-2.381 0l-1.015-4.206a1.224 1.224 0 0 0-.903-.902l-4.206-1.016c-1.25-.301-1.25-2.079 0-2.38l4.206-1.016c.446-.107.795-.456.903-.903l1.015-4.205Z"
                fill="url(#r)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M71.35 12.454a2.041 2.041 0 1 0 0-4.082 2.041 2.041 0 0 0 0 4.082Zm0 1.53a3.571 3.571 0 1 0 0-7.142 3.571 3.571 0 0 0 0 7.143Z"
                fill="url(#s)"
            />
            <path
                d="M134.811 68.651a1.02 1.02 0 0 1 1.265-1.234l5.104 1.434a1.02 1.02 0 0 1 .437 1.713l-3.795 3.704a1.02 1.02 0 0 1-1.701-.479l-1.31-5.138Z"
                fill="url(#t)"
            />
            <path
                d="M15.158 59.889a1.02 1.02 0 0 1 1.233 1.266l-1.441 5.103a1.02 1.02 0 0 1-1.713.434l-3.699-3.799a1.02 1.02 0 0 1 .48-1.7l5.14-1.304Z"
                fill="url(#u)"
            />
            <path
                d="M112.488 130.409a1.02 1.02 0 0 1 1.233 1.266l-1.441 5.103a1.02 1.02 0 0 1-1.713.434l-3.699-3.799a1.02 1.02 0 0 1 .481-1.701l5.139-1.303Z"
                fill="url(#v)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M139.54 42.178a2.041 2.041 0 1 0 0-4.082 2.041 2.041 0 0 0 0 4.082Zm0 1.53a3.572 3.572 0 1 0 0-7.142 3.572 3.572 0 0 0 0 7.143Z"
                fill="url(#w)"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1={74.992}
                    y1={-11.427}
                    x2={76.352}
                    y2={223.337}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity={0} />
                    <stop offset={1} stopColor="#8EE2F4" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1={28.76}
                    y1={27.822}
                    x2={120.256}
                    y2={34.315}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="c"
                    x1={26.12}
                    y1={94.553}
                    x2={158.093}
                    y2={96.915}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#BCF3FF" />
                </linearGradient>
                <linearGradient
                    id="d"
                    x1={39.613}
                    y1={47.056}
                    x2={110.585}
                    y2={47.056}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#65C8DE" />
                    <stop offset={1} stopColor="#D2F7FF" />
                </linearGradient>
                <linearGradient
                    id="e"
                    x1={39.613}
                    y1={66.113}
                    x2={110.585}
                    y2={66.113}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#65C8DE" />
                    <stop offset={1} stopColor="#D2F7FF" />
                </linearGradient>
                <linearGradient
                    id="f"
                    x1={39.613}
                    y1={85.166}
                    x2={110.585}
                    y2={85.166}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#65C8DE" />
                    <stop offset={1} stopColor="#D2F7FF" />
                </linearGradient>
                <linearGradient
                    id="g"
                    x1={39.613}
                    y1={104.223}
                    x2={110.585}
                    y2={104.223}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#65C8DE" />
                    <stop offset={1} stopColor="#D2F7FF" />
                </linearGradient>
                <linearGradient
                    id="i"
                    x1={6.41}
                    y1={117.675}
                    x2={85.345}
                    y2={124.199}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#BCF3FF" />
                </linearGradient>
                <linearGradient
                    id="k"
                    x1={95.566}
                    y1={22.773}
                    x2={155.036}
                    y2={24.504}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#BCF3FF" />
                </linearGradient>
                <linearGradient
                    id="l"
                    x1={45.37}
                    y1={102.545}
                    x2={11.937}
                    y2={102.545}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D2F7FF" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="m"
                    x1={45.343}
                    y1={123.611}
                    x2={12.197}
                    y2={123.611}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D2F7FF" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="n"
                    x1={45.343}
                    y1={112.54}
                    x2={12.197}
                    y2={112.54}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D2F7FF" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="o"
                    x1={36.865}
                    y1={91.472}
                    x2={13.11}
                    y2={91.472}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.244} stopColor="#D2F7FF" />
                    <stop offset={1} stopColor="#6BCBE0" />
                </linearGradient>
                <linearGradient
                    id="q"
                    x1={57.261}
                    y1={124.394}
                    x2={81.912}
                    y2={124.554}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="r"
                    x1={8.888}
                    y1={12.494}
                    x2={33.539}
                    y2={12.654}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="s"
                    x1={67.771}
                    y1={8.49}
                    x2={74.961}
                    y2={8.537}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="t"
                    x1={132.359}
                    y1={72.196}
                    x2={139.756}
                    y2={65.069}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="u"
                    x1={11.617}
                    y1={57.433}
                    x2={18.734}
                    y2={64.839}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="v"
                    x1={108.947}
                    y1={127.953}
                    x2={116.064}
                    y2={135.359}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <linearGradient
                    id="w"
                    x1={135.961}
                    y1={38.214}
                    x2={143.151}
                    y2={38.261}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#90E3F5" />
                    <stop offset={1} stopColor="#65C8DE" />
                </linearGradient>
                <filter
                    id="h"
                    x={0.653}
                    y={72.117}
                    width={58.672}
                    height={72.02}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={1.748} dy={4.08} />
                    <feGaussianBlur stdDeviation={4.371} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0" />
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_6510_65484"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_6510_65484"
                        result="shape"
                    />
                </filter>
                <filter
                    id="j"
                    x={92.723}
                    y={0.755}
                    width={56.341}
                    height={37.52}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx={3.497} dy={2.331} />
                    <feGaussianBlur stdDeviation={3.788} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0" />
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_6510_65484"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_6510_65484"
                        result="shape"
                    />
                </filter>
                <filter
                    id="p"
                    x={59.524}
                    y={87.387}
                    width={67.058}
                    height={30.613}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation={6.074}
                        result="effect1_foregroundBlur_6510_65484"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const RewriteIcon = () => {
    return (
        <svg
            width={18}
            height={19}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.39 7.51h3.376V4.135"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.625 5.126a6.18 6.18 0 0 1 8.747 0l2.39 2.384M5.61 11.49H2.233v3.375"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.372 13.873a6.18 6.18 0 0 1-8.747 0l-2.39-2.383"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const EditIcon = () => {
    return (
        <svg
            width={20}
            height={21}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 13H7.5v-2.5L15 3l2.5 2.5L10 13ZM13.125 4.875l2.5 2.5"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.875 9.875v6.875a.624.624 0 0 1-.625.625H3.75a.625.625 0 0 1-.625-.625V4.25a.625.625 0 0 1 .625-.625h6.875"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CopyIcon = () => {
    return (
        <svg
            width={18}
            height={17}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.375 4.781v9.563c0 .293-.252.531-.563.531H3.939c-.311 0-.563-.238-.563-.531V4.78c0-.293.252-.531.563-.531h7.874c.311 0 .563.238.563.531Z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.625 12.75V2.656c0-.14-.06-.276-.165-.375a.58.58 0 0 0-.398-.156H5.626"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const LikeInactiveIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 8.125h3.75v8.125H2.5a.625.625 0 0 1-.625-.625V8.75a.625.625 0 0 1 .625-.625v0ZM6.25 8.125l3.125-6.25a2.5 2.5 0 0 1 2.5 2.5V6.25h4.836a1.242 1.242 0 0 1 1.234 1.406l-.937 7.5a1.25 1.25 0 0 1-1.235 1.094H6.25"
                stroke="#707070"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DislikeInactiveIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 3.75h3.75v8.125H2.5a.625.625 0 0 1-.625-.625V4.375A.625.625 0 0 1 2.5 3.75v0ZM6.25 11.875l3.125 6.25a2.5 2.5 0 0 0 2.5-2.5V13.75h4.836a1.243 1.243 0 0 0 1.234-1.406l-.937-7.5a1.25 1.25 0 0 0-1.235-1.094H6.25"
                stroke="#707070"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const LikeActiveIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 8.125H6.25V16.25H2.5C2.33424 16.25 2.17527 16.1842 2.05806 16.0669C1.94085 15.9497 1.875 15.7908 1.875 15.625V8.75C1.875 8.58424 1.94085 8.42527 2.05806 8.30806C2.17527 8.19085 2.33424 8.125 2.5 8.125Z"
                fill="#D9D9D9"
            />
            <path
                d="M6.25 8.125L9.375 1.875C10.038 1.875 10.6739 2.13839 11.1428 2.60723C11.6116 3.07607 11.875 3.71196 11.875 4.375V6.25H16.7109C16.8882 6.24956 17.0635 6.28706 17.225 6.35997C17.3866 6.43288 17.5306 6.53953 17.6476 6.67273C17.7645 6.80593 17.8516 6.96262 17.9029 7.13226C17.9543 7.3019 17.9687 7.48056 17.9453 7.65625L17.0078 15.1562C16.9699 15.4573 16.8237 15.7343 16.5966 15.9356C16.3695 16.1368 16.0769 16.2486 15.7734 16.25H6.25"
                fill="#A6DF50"
            />
        </svg>
    );
};

export const DislikeActiveIcon = () => {
    return (
        <svg
            width={20}
            height={21}
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 3.83887H6.25V11.9639H2.5C2.33424 11.9639 2.17527 11.898 2.05806 11.7808C1.94085 11.6636 1.875 11.5046 1.875 11.3389V4.46387C1.875 4.29811 1.94085 4.13914 2.05806 4.02193C2.17527 3.90472 2.33424 3.83887 2.5 3.83887Z"
                fill="#D9D9D9"
            />
            <path
                d="M6.25 11.9639L9.375 18.2139C10.038 18.2139 10.6739 17.9505 11.1428 17.4816C11.6116 17.0128 11.875 16.3769 11.875 15.7139V13.8389H16.7109C16.8882 13.8393 17.0635 13.8018 17.225 13.7289C17.3866 13.656 17.5306 13.5493 17.6476 13.4161C17.7645 13.2829 17.8516 13.1262 17.9029 12.9566C17.9543 12.787 17.9687 12.6083 17.9453 12.4326L17.0078 4.93262C16.9699 4.63154 16.8237 4.35454 16.5966 4.15329C16.3695 3.95204 16.0769 3.84028 15.7734 3.83887H6.25"
                fill="#707070"
                fillOpacity={0.5}
            />
        </svg>
    );
};

export const UndoIcon = () => {
    return (
        <svg
            width={16}
            height={14}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 5.5H1v-4"
                stroke="#707070"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.583 11.594a6.747 6.747 0 0 0 3.424 1.78 6.865 6.865 0 0 0 3.864-.368 6.649 6.649 0 0 0 3.002-2.394A6.372 6.372 0 0 0 15 7a6.372 6.372 0 0 0-1.127-3.612A6.649 6.649 0 0 0 10.87.994 6.865 6.865 0 0 0 7.007.625a6.748 6.748 0 0 0-3.424 1.78L1 4.91"
                stroke="#707070"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
                stroke="#000"
                strokeWidth={1.5}
                strokeMiterlimit={10}
            />
            <path
                d="M6.875 10h6.25M10 6.875v6.25"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const TickIcon = () => {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m16.875 5.625-8.75 8.75L3.75 10"
                stroke="#707070"
                strokeWidth={0.75}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PropAddSearchIcon = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.875 18.75a7.875 7.875 0 1 0 0-15.75 7.875 7.875 0 0 0 0 15.75ZM16.443 16.444 21 21"
                stroke="#000"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const PropAddCloseIcon = () => {
    return (
        <svg
            width={15}
            height={15}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.004 1 13.4 13.396M13.395 1 .998 13.396"
                stroke="#9D9D9D"
                strokeWidth={1.3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const HistDelIcon = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="ud-aid-hist-dropdown-del-icon"
        >
            <path
                d="M20.25 5.25H3.75M9.75 9.75v6M14.25 9.75v6M18.75 5.25V19.5a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75V5.25M15.75 5.25v-1.5a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5v1.5"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
